export default "__VITE_ASSET__D1CKlzO5__"